import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Projects from './ProjectsList';
import Project from './Project';


const styles = theme => ({

    root: {
    },
    header: {

        backgroundColor: theme.palette.custom.headerBack,
        boxShadow: "inset 0 0 20px rgba(0,0,0,.5)",
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        textAlign: 'center'
    },

    body: {

        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit,
    },

    space: {
        marginTop: theme.spacing.unit * 1,
        marginBottom: theme.spacing.unit * 1,
    },

    white: {
        color: 'white',

    },

    button: {
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,

    },

    headerButtons: {
        marginTop: theme.spacing.unit * 5    
    },

    title: {
        marginBottom: theme.spacing.unit * 2
    }


});

class Home extends React.Component {


    constructor(props) {

        super(props);

        this.state = {
            projects: {}
        };

    }


    render() {

        const { classes, projects } = this.props;
        let viewProjectId = this.props.match.params.id;

        if (viewProjectId) {

            let project = null;
            if (projects) {
                project = projects.find(p => p.projectId == viewProjectId);
            }

            return (
                <Project project={project} />
            );
        } else {
            return (
                <div className={classes.root}>
                    <Grid container direction="column" justify="center" alignItems="center" className={classes.header} >
                        <Grid item className={classes.space}>
                            <Typography variant="h2" className={classes.white} >
                                Projects
                            </Typography>
                        </Grid>
                        <Grid item className={classes.space}>
                            <Typography variant="body1" className={classes.white} >
                                A preview of the notable projects I've worked on over the years
                            </Typography>
                        </Grid>

                    </Grid>
                    <Grid container direction="column" justify="center" alignItems="center" className={classes.body} >
                        <Grid item>
                            <Projects projects={projects} />
                        </Grid>

                    </Grid>

                </div>
            );
        }
    }

}

export default withStyles(styles)(Home);